module.exports = __webpack_public_path__ + "img/avatar0.4edd7906.png";